import { t } from 'i18next';

export const getPartnershipValues = (withSecondaryApplicant?: boolean) => ({
  label: withSecondaryApplicant
    ? t('shared:personalInformation.inputs.partnership.label.withSecondary')
    : t('shared:personalInformation.inputs.partnership.label.withoutSecondary'),
  placeholder: t('shared:personalInformation.inputs.partnership.placeholder'),
  saco: t('shared:personalInformation.inputs.partnership.values.saco'),
  tco: t('shared:personalInformation.inputs.partnership.values.tco'),
  hsb: t('shared:personalInformation.inputs.partnership.values.hsb'),
  spp: t('shared:personalInformation.inputs.partnership.values.spp'),
  noneApplies: t(
    'shared:personalInformation.inputs.partnership.values.noneApplies',
  ),
});
